import { useQuery } from '@tanstack/react-query';
import { customerService } from '../services/api';

// O lead carrega o departamento como internal_name (o serviço de IA só
// devolve esse identificador), então a lista de departamentos é o que
// transforma o slug em nome legível.
export const useDepartments = () =>
  useQuery({
    queryKey: ['departments'],
    queryFn: () => customerService.getDepartments().then((res) => res.data?.results ?? []),
    staleTime: 5 * 60 * 1000,
  });

// Departamento removido/desconhecido cai no próprio internal_name — pior que
// o nome, melhor que sumir da tela.
export const getDepartmentName = (departments, internalName) => {
  if (!internalName) return '';
  const found = (departments || []).find((d) => d.internal_name === internalName);
  return found?.name || internalName;
};
